/*jshint multistr: true */

import { Cowboy } from '../lib/jquery.ba-throttle-debounce.min.js';
require('../lib/magnific_popup_main.js')
require('../lib/nanoScrollerJS.js')
require('../lib/glDatePicker.js')
require('../lib/jquery.inputmask.bundle.js')
require('../lib/jquery.clickout.js')
require('../lib/iframeResizer.min.js')
require('../lib/stickyfill.js')
require('../lib/jquery.dotdotdot.min.js')
require('../lib/jquery-ui.js')
require('../lib/jquery-cookie-1-4-1.js')

require('./site_config.js')
require('./modules/analytics_events.js')
require('./modules/navigation.js')
require('./modules/user_profile.js')
require('./modules/sticky.js')
require('./modules/load_more.js')
require('./modules/form_submit.js')
require('./modules/ticker.js')

$.throttle = Cowboy.throttle;
$.debounce = Cowboy.debounce;

$(document).ready(function () {

    var classNames = [];
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios');
    if (navigator.userAgent.match(/android/i)) classNames.push('device-android');

    var html = document.getElementsByTagName('html')[0];

    if (classNames.length) classNames.push('on-device');
    if (html.classList) html.classList.add.apply(html.classList, classNames);

    /* AJAX SETUP */
    var csrftoken = $.cookie('csrftoken');

    function csrfSafeMethod(method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    function sameOrigin(url) {
        // test that a given url is a same-origin URL
        // url could be relative or scheme relative or absolute
        var host = document.location.host; // host + port
        var protocol = document.location.protocol;
        var sr_origin = '//' + host;
        var origin = protocol + sr_origin;
        // Allow absolute or scheme relative URLs to same origin
        return (url == origin || url.slice(0, origin.length + 1) == origin + '/') ||
            (url == sr_origin || url.slice(0, sr_origin.length + 1) == sr_origin + '/') ||
            // or any other URL that isn't scheme relative or absolute i.e relative.
            !(/^(\/\/|http:|https:).*/.test(url));
    }

    $.ajaxSetup({

        beforeSend: function (xhr, settings) {
            if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
                // Send the token to same-origin, relative URLs only.
                // Send the token only if the method warrants CSRF protection
                // Using the CSRFToken value acquired earlier
                xhr.setRequestHeader("X-CSRFToken", csrftoken);
            }
        }
    });
    /* END AJAX SETUP */

    function selectionInjection() {
        $(".article__content").on('copy', function (e) {

            var selectedText = window.getSelection();

            var copyAddedText = "<br /><br /> Več na: <a href='" + document.location.href + "'>" +
                document.location.href + "</a> - " + document.location.hostname;

            var selectionHelper = $('<div>', { style: { position: 'absolute', left: '-99999px' }, html: selectedText + copyAddedText });
            $('body').append(selectionHelper);

            selectedText.selectAllChildren(selectionHelper[0]);

            window.setTimeout(function () {
                selectionHelper.remove();
            }, 0);
        });
    }

    function initSticky() {

        if ($('.sticky').length > 0) {

            $('.sticky').Stickyfill();
            $('.sticky').addClass('js_initStickyFN');

        }

        setTimeout(function () {
            Stickyfill.rebuild();
        }, 1500);
    }

    function initNano() {

        $('.nano').nanoScroller({
            'preventPageScrolling': true,
            'iOSNativeScrolling': true,
        });
    }

    function sidebarFeed() {
        /**
         * Adjusts sidebar feed height and visibility of articles based on window width.
         * Limits visible articles to three on desktop and initializes nanoScroller if available.
         */
        const windowWidth = window.innerWidth;
        const sidebarContents = document.querySelectorAll('.js_sidebarFeed');

        sidebarContents.forEach(sidebarContent => {
            const allArticles = sidebarContent.querySelectorAll('article');
            if (allArticles.length === 0) return;

            if (windowWidth > 1024) {
                const mainContent = document.querySelector('.js_sidebarFeedHeightElement');
                if (!mainContent) return;

                setTimeout(() => {
                    const firstThree = Array.from(allArticles).slice(0, 3);
                    const heightOf3 = firstThree.reduce((sum, el) => {
                        const style = getComputedStyle(el);
                        const marginTop = parseFloat(style.marginTop);
                        const marginBottom = parseFloat(style.marginBottom);
                        return sum + el.offsetHeight + marginTop + marginBottom;
                    }, 0);

                    sidebarContent.style.height = heightOf3 + 'px';

                    allArticles.forEach((el, i) => {
                        el.style.display = i < 3 ? '' : 'none';
                    });

                    if (typeof jQuery.fn.nanoScroller === 'function') {
                        jQuery('.sidebar__feed--nano').nanoScroller({
                            preventPageScrolling: true,
                            iOSNativeScrolling: true,
                        });
                    } else {
                        console.warn('nanoScroller is not initialized');
                    }
                }, 500);
            } else {
                allArticles.forEach(el => el.style.display = '');
                sidebarContent.style.height = '';
            }
        });
    }

    function initOnLoad() {

        $('.js_initOnLoad').removeClass('hidden');

    }

    function expandToolDescription() {

        var $tool = $('.js_tool');

        if ($tool.length) {

            var $expandBtn = $tool.find('.js_showFullDescription'),
                $toolDescription = $tool.find('.js_toggleDescription');

            $expandBtn.on('click', function (event) {

                event.preventDefault();
                $toolDescription.toggleClass('is_hidden');

            });
        }
    }

    function initIframeResize() {
        $('.tes_widget > iframe').iFrameResize();
        $('.article__more > div > iframe').iFrameResize();
    }

    setTimeout(function () {
        initIframeResize();
    }, 800);

    function lineClamp() {

        $('.js_lineclamp ').dotdotdot({});

        setTimeout(function () {
            $('.js_lineclamp ').trigger("update");
        }, 300);
    }

    function cookieControl() {

        window.forbiddenAnalyticsCookie = window.getCookie('CC__analiticni_piskotki__') || 1;
        window.forbiddenAdsCookie = window.getCookie('CC__oglasevalski_piskotki__') || 1;
        window.forbiddenSocialCookie = window.getCookie('CC__druzbena_omrezja_piskotki__') || 1;

        $('#analiticni_piskotki_r' + forbiddenAnalyticsCookie).prop('checked', true);
        $('#oglasevalski_piskotki_r' + forbiddenAdsCookie).prop('checked', true);
        $('#druzbena_omrezja_piskotki_r' + forbiddenSocialCookie).prop('checked', true);

        $('#analiticni_piskotki_table').css('opacity', 0.6 + (forbiddenAnalyticsCookie * 0.4));
        $('#oglasevalski_piskotki_table').css('opacity', 0.6 + (forbiddenAdsCookie * 0.4));
        $('#druzbena_omrezja_piskotki_table').css('opacity', 0.6 + (forbiddenSocialCookie * 0.4));

        $('.radiobutton--group [name=analiticni_piskotki]').on('change', function () {
            window.setCookie('CC__analiticni_piskotki__', $(this).val(), 365);
            $('#analiticni_piskotki_table').css('opacity', 0.6 + ($(this).val() * 0.4));
        });

        $('.radiobutton--group [name=oglasevalski_piskotki]').on('change', function () {
            window.setCookie('CC__oglasevalski_piskotki__', $(this).val(), 365);
            $('#oglasevalski_piskotki_table').css('opacity', 0.6 + ($(this).val() * 0.4));
        });

        $('.radiobutton--group [name=druzbena_omrezja_piskotki]').on('change', function () {
            window.setCookie('CC__druzbena_omrezja_piskotki__', $(this).val(), 365);
            $('#druzbena_omrezja_piskotki_table').css('opacity', 0.6 + ($(this).val() * 0.4));
        });

    }

    /**
     * Displays a sticky footer banner when the user scrolls down a quarter of the page height.
     */
    const showStickyFooterBanner = () => {
        var banner = document.querySelector('.js_stickyFooterBanner');
        var bannerVisible = false;

        if (!banner || bannerVisible) return;

        function showBanner() {
            var pageHeight = document.body.scrollHeight;
            var showBannerPoint = pageHeight / 4;
            var windowScroll = window.pageYOffset || document.documentElement.scrollTop || 0;

            if (windowScroll >= showBannerPoint) {
                banner.classList.add('is-visible');
                bannerVisible = true;
            }
        }

        // Use existing throttle utility for consistency
        window.addEventListener('scroll', Cowboy.throttle(500, showBanner));
    };

    function accordion() {
        $('#js_accordion').accordion({
            header: ".js_accoheader",
            heightStyle: 'content',
            active: true,
            collapsible: true,
            icons: {
                "header": "ui-icon-plus",
                "activeHeader": "ui-icon-minus"
            },
            classes: {
                "ui-accordion-header-collapsed": "ui-accordion__header-collapsed",
                "ui-accordion-header-active": "ui-accordion__header-active",
                "ui-accordion-content-active": "ui-accordion__content-active"
            }
        });
    }

    $.fn.contentIframeHandler = function (selector) {

        return $(this).each(function () {

            var container = $(this).closest('.article__aditionl_content'),
                wrapper = null,
                iframe = $(this),
                resizeTimeout = null,
                time = 200,
                ww = null,
                wbreak = 1024,
                wwide = 1370,
                type = null,
                dataHeight = {
                    mob: null,
                    desk: null,
                    wide: null
                };

            var init = function () {
                if (iframe.length) {
                    ww = window.innerWidth;
                    setHeights();
                    initSelector();
                    if (type === 'rwd') $(window).resize(onResize);
                }
                else return;
            };

            var setHeights = function () {
                var arr = [];
                if (iframe.attr('data-height')) arr = iframe.attr('data-height').split('x');
                if (arr.length > 1) {
                    dataHeight.mob = arr[0];
                    dataHeight.desk = arr[1];
                    dataHeight.wide = arr[2];
                    iframe.removeAttr('height');
                    type = 'rwd';
                } else if (arr.length === 1) {
                    dataHeight.desk = arr[0];
                    iframe.removeAttr('height');
                    type = 'fixed';
                }
                else type = 'fixed';
            };

            var initSelector = function () {
                if (type === 'rwd') {
                    if (dataHeight.wide && ww > wwide) initWide();
                    if (dataHeight.desk && ww > wbreak && ww < wwide) initDesk();
                    if (dataHeight.mob && ww < wbreak) initMobile();
                } else {
                    if (iframe.attr('height') || dataHeight.desk) initUniversal();
                    else return;
                }
            };

            var initUniversal = function () {
                var hData = parseInt(iframe.attr('height'), 10) || parseInt(dataHeight.desk, 10);
                addWrapper();
                calcHeight(hData);
            };

            var initWide = function () {
                var hData = parseInt(dataHeight.wide, 10);
                addWrapper();
                calcHeight(hData);
            };

            var initDesk = function () {
                var hData = parseInt(dataHeight.desk, 10);
                addWrapper();
                calcHeight(hData);
            };

            var initMobile = function () {
                var hData = parseInt(dataHeight.mob, 10);
                addWrapper();
                calcHeight(hData);
            };

            var addWrapper = function () {
                if (wrapper === null) {
                    iframe.wrap('<div class="js_iframeWrapper"></div>');
                    wrapper = iframe.closest('.js_iframeWrapper');
                }
            };

            var calcHeight = function (hData) {
                var w = container.width(),
                    h = parseInt(hData, 10),
                    calcHeight = Math.ceil(h / w * 100) + 2;
                wrapper.css({ 'paddingBottom': calcHeight + '%' });
                iframe.removeAttr('height');
            };

            var onResize = function () {
                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(function () {
                    // do stuff on resize
                    ww = window.innerWidth;
                    initSelector();
                }, time);
            };
            init();
        });
    };

    initOnLoad();
    selectionInjection();
    initSticky();
    initNano();
    expandToolDescription();
    initIframeResize();
    cookieControl();
    lineClamp();
    showStickyFooterBanner();
    accordion();
    $('.article__aditionl_content iframe').contentIframeHandler();
    sidebarFeed();

    // use debounce so function is not called multiple times on windows resize event
    $(window).resize($.debounce(300, sidebarFeed));

});
